import { Box } from "@mui/material";
import { NavLink } from "react-router-dom";
import { ChesslaBrand } from "./ChesslaBrand";
import { MobileTopMenu } from "./MobileTopMenu";

interface AppMobileNavigationProps {
  pathname: string;
  onboardingCompleted: boolean;
  isAnalyzing: boolean;
  onLogout: () => void;
}

export const AppMobileNavigation = ({
  pathname,
  onboardingCompleted,
  isAnalyzing,
  onLogout,
}: AppMobileNavigationProps) => (
  <Box
    component="header"
    sx={{
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      height: "var(--mobile-app-bar-height, 44px)",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      // viewport-fit=cover lets landscape iPhones draw under the notch; keep the bar's content clear of it.
      pl: "max(10px, env(safe-area-inset-left))",
      pr: "env(safe-area-inset-right)",
      bgcolor: "background.default",
      borderBottom: "2px solid",
      borderColor: "primary.main",
      color: "primary.main",
      zIndex: 1200,
      transition: "none",
    }}
  >
    <Box component={NavLink} to="/about" aria-label="Chessla — About" sx={{ color: "inherit", textDecoration: "none" }}>
      <ChesslaBrand />
    </Box>
    <Box sx={{ ml: "auto", display: "flex", alignItems: "center" }}>
      <MobileTopMenu
        key={pathname}
        pathname={pathname}
        onboardingCompleted={onboardingCompleted}
        isAnalyzing={isAnalyzing}
        onLogout={onLogout}
      />
    </Box>
  </Box>
);
